import { createFileRoute, useSearch } from '@tanstack/react-router';
import { useCallback } from 'react';
import {
  ContainerSelectionArgs,
  ContainerTypeLegacy,
  ManageSitesView,
  navigateTo,
  useAuth,
  useGetViewer,
  validateGrainBinSupportAccess,
} from '@amber-ui/core';

function ManageSitesRoute() {
  const { viewer } = useGetViewer();
  // Read acct from URL search params (source of truth)
  const { acct } = useSearch({ strict: false }) as { acct?: string };
  const { account_id: session_account_id } = useAuth();
  const effectiveAccountId = acct || session_account_id || '';

  const goContainer = useCallback((selected: ContainerSelectionArgs) => {
    if (selected.container_type === ContainerTypeLegacy.bin) {
      navigateTo('/grain_bin/dashboard', selected);
    } else if (selected.container_type === ContainerTypeLegacy.barge) {
      navigateTo('/barge/dashboard', selected);
    } else if (selected.container_type === ContainerTypeLegacy.pile) {
      navigateTo('/pile/dashboard', selected);
    }
  }, []);

  if (!viewer) return null;

  // Access guard: redirect accounts without grain_bin_support
  const { account } = viewer;
  if (!validateGrainBinSupportAccess(account, viewer)) {
    return null;
  }

  const grain_bin_ids = viewer.account.grain_bin_links
    .filter(({ grain_bin }) => !grain_bin.archived)
    .map(({ grain_bin_id }) => grain_bin_id);

  return (
    <ManageSitesView
      account_id={effectiveAccountId}
      user_id={viewer.user_id}
      grain_bin_ids={grain_bin_ids}
      goContainer={goContainer}
    />
  );
}

export const Route = createFileRoute('/_auth/grain/operations/manage')({
  component: ManageSitesRoute,
});
